import React, { useState } from 'react';
import _ from 'lodash';
import CommonModal from './common/Modal';
import Tippy from '../../components/ReactTippy';
import { getOneMasterTypeNameCompanyNumber } from '../../utilities/commonUtil';
import { messageUtility } from '../../utilities/messageUtility';
import SessionStorageService from '../../services/utilities/SessionStorageService';

export const InvitationConfirmDialog = ({
  visible,
  onCancel,
  onLogout,
  onConfirm,
  onReport,
  invitationEntities,
}) => {
  const [nameVerified, setNameVerified] = useState(false);
  const [addressVerified, setAdressVerified] = useState(false);
  const companyUserInvitationStatus =
    invitationEntities.company_user_invitation_status;
  const inviteeCompanyName =
    _.get(companyUserInvitationStatus, 'invitee_company_user.company.name') ||
    '';
  const inviteeCompanyAddress =
    _.get(
      companyUserInvitationStatus,
      'invitee_company_user.company.address'
    ) || '';
  const inviteeOneMasterFlag = _.get(
    companyUserInvitationStatus,
    'invitee_company_user.company.one_master_flag'
  );
  const inviteeCompanyNumber = _.get(
    companyUserInvitationStatus,
    'invitee_company_user.company.company_number'
  );
  const inviteeOneMasterTypeNameCompanyNumber = getOneMasterTypeNameCompanyNumber(
    inviteeOneMasterFlag,
    inviteeCompanyNumber
  );
  const inviterCompanyName =
    _.get(companyUserInvitationStatus, 'inviter_company_user.company.name') ||
    '';
  const inviterUserFullName =
    _.get(companyUserInvitationStatus, 'inviter_company_user.user.fullname') ||
    '';
  return (
    <React.Fragment>
      {visible && (
        <CommonModal visible={visible}>
          <div className='dialog dialog--wide dialog--modal'>
            <div className='dialog__header'>
              <span className='dialog__title'>会社名と住所の確認</span>
            </div>
            <div className='dialog__body'>
              <p className='dialog__text-box dialog__text'>
                下記の会社に招待されました。ご自身の所属している会社名と住所でお間違いないかご確認ください。<br />
                ご自身の所属している会社名・住所と異なる場合や、判断できない場合は「所属会社ではない」を押下してください。
              </p>
              <span className='dialog__text-box dialog__text'>
                会社種別：{inviteeOneMasterTypeNameCompanyNumber}
                <br />
              </span>
              <span className='dialog__text-box dialog__text'>会社名：</span>
              <span className='dialog__text-box dialog__text dialog__text--large text--red--primary'>
                {inviteeCompanyName}
                <br />
              </span>
              <span className='checkbox ccus-password-visible'>
                <label className='checkbox'>
                  <input
                    type='checkbox'
                    readOnly
                    checked={nameVerified}
                    onClick={() => setNameVerified(checked => !checked)}
                  />
                  <i className='i-square i-3x' />自身の所属する会社名および会社種別で間違いないことを確認
                </label>
              </span>
              <span className='dialog__text-box dialog__text'><br />住所：</span>
              <span className='dialog__text-box dialog__text dialog__text--large text--red--primary'>
                {inviteeCompanyAddress}
                <br />
              </span>
              <span className='checkbox ccus-password-visible'>
                <label className='checkbox'>
                  <input
                    type='checkbox'
                    readOnly
                    checked={addressVerified}
                    onClick={() => setAdressVerified(checked => !checked)}
                  />
                  <i className='i-square i-3x' />自身の所属する会社の住所で間違いないことを確認
                </label>
              </span>
              <p className='dialog__text-box dialog__text'>
                <br />                
                招待者：{inviterCompanyName}　{inviterUserFullName}様
              </p>
            </div>
            <div className='dialog__footer dialog__footer--horizontal'>
              {invitationEntities.unconfirmed_company_users_count ===
                invitationEntities.company_users_count ||
              SessionStorageService.getDirectLink() ? (
                <button className='btn-fixedsize--sub' onClick={onLogout}>
                  保留してログアウト
                </button>
              ) : (
                <button className='btn-fixedsize--sub' onClick={onCancel}>
                  {messageUtility.getMessage('I-000-008')}
                </button>
              )}
              <Tippy
                duration={10}
                distance={24}
                arrow='true'
                arrowType='sharp'
                delay={[100, 100]}
                disable={nameVerified && addressVerified}
                placement='top'
                followCursor={true}
                html={
                  <div className='tippy-tooltip'>
                    チェック項目の確認を行ってください。
                  </div>
                }
              >
                <span
                  onClick={nameVerified && addressVerified && onConfirm}
                >
                  <button
                    className={
                      nameVerified && addressVerified
                      ? 'btn-fixedsize--effective'
                      : 'btn-fixedsize--disabled'
                    }
                  >
                    所属会社である
                  </button>
                </span>
              </Tippy>
              <button className='btn-fixedsize--negative' onClick={onReport}>
                所属会社ではない
              </button>
            </div>
          </div>
        </CommonModal>
      )}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/InvitationConfirmDialog.jsx